import { API_PREFIX, ROUTES } from '@stockstop/shared';
import { useEffect, useState } from 'react';

/**
 * Die Anmeldeseite.
 *
 * Bewusst ein Verweis und kein Knopf mit `onClick`: Die Anmeldung ist eine
 * Weiterleitung zu Google, kein Datenaustausch im Hintergrund. Ein `<a>` verhält
 * sich dabei richtig — mit Tastatur erreichbar, im neuen Tab zu öffnen, und ohne
 * JavaScript funktionsfähig.
 *
 * Der Server leitet nach einem gescheiterten Versuch mit `?anmeldung=<grund>`
 * hierher zurück. Der Grund wird angezeigt und danach aus der Adresse entfernt:
 * Sonst stünde die Meldung nach einem Neuladen erneut da, obwohl gerade nichts
 * fehlgeschlagen ist.
 */

const REASONS: Record<string, string> = {
  abgelehnt: 'Die Anmeldung wurde bei Google abgebrochen.',
  abgelaufen: 'Der Anmeldevorgang ist abgelaufen. Bitte noch einmal versuchen.',
  fehlgeschlagen: 'Die Anmeldung konnte nicht abgeschlossen werden.',
  'fremde-organisation':
    'Dieses Google-Konto gehört nicht zur zugelassenen Organisation. ' +
    'Bitte mit dem Geschäftskonto anmelden.',
};

export const LoginScreen = (): React.JSX.Element => {
  const [reason, setReason] = useState<string | null>(null);

  useEffect(() => {
    const value = new URLSearchParams(window.location.search).get('anmeldung');
    if (!value) return;

    setReason(REASONS[value] ?? 'Die Anmeldung ist fehlgeschlagen.');
    window.history.replaceState(null, '', window.location.pathname);
  }, []);

  return (
    <main className="login">
      <div className="login__card">
        <h1 className="login__title">
          StockStop
          <span className="muted"> · Stop-Loss Verwaltung</span>
        </h1>

        <p className="login__lead">
          Stop-Loss-Marken für dein Portfolio setzen, verfolgen und beim Broker nachhalten.
        </p>

        {reason ? (
          <p className="hint hint--error login__reason" role="alert">
            {reason}
          </p>
        ) : null}

        <a className="button-primary login__action" href={`${API_PREFIX}${ROUTES.auth.login}`}>
          Mit Google anmelden
        </a>

        <p className="muted small login__note">
          Die Anmeldung läuft über dein Google-Konto. StockStop sieht dabei nur deinen Namen, deine
          Adresse und dein Profilbild — kein Passwort.
        </p>
      </div>
    </main>
  );
};
